import { AppStore } from './../../../shared/store/lookup-store.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-search',
  templateUrl: './job-search.component.html',
  styleUrls: ['./job-search.component.scss']
})
export class JobSearchComponent implements OnInit {

  constructor(public lookupStore:AppStore) { }

  ngOnInit() {
  }

}
